import * as React from "react"
import useSession from "@digits-shared/hooks/useSession"
import { AspectCode } from "@digits-shared/session/AspectCode"
import { JWTPermissionFlag } from "@digits-shared/session/jwt/jwtPermissions"
import { useHasPermission } from "src/frontend/components/Shared/Permissions/Requires"
import type FrontendSession from "src/frontend/session"
import {
  FrontendPermissionModule,
  FrontendPermissionSource,
} from "src/frontend/session/permissionModule"

export function useCategoryManagerPermissions() {
  const { hasAccessToAspect } = useSession<FrontendSession>()

  const hasCategoryManager = hasAccessToAspect(AspectCode.CategoryManager)

  const canCreate = useHasPermission({
    source: FrontendPermissionSource.LegalEntity,
    module: FrontendPermissionModule.ChartOfAccounts,
    flag: JWTPermissionFlag.Create,
  })

  const canUpdate = useHasPermission({
    source: FrontendPermissionSource.LegalEntity,
    module: FrontendPermissionModule.ChartOfAccounts,
    flag: JWTPermissionFlag.Update,
  })

  return React.useMemo(
    () => ({
      hasCreatePermission: hasCategoryManager && canCreate,
      hasUpdatePermission: hasCategoryManager && canUpdate,
      isViewOnly: !hasCategoryManager || !canUpdate,
    }),
    [hasCategoryManager, canCreate, canUpdate]
  )
}
